import React from "react";
import { H4TextContainer } from "./h4-text-styles";

interface H4TextProps {
    children: any;
    className?: string;
    color?: string;
}


const H4Text = ({children = '', className='', color=''}:H4TextProps) => {
        return (
        <H4TextContainer color={color} className={className}>
            {children}
        </H4TextContainer>
    )
} 
export default H4Text;